import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';
@Component({
  selector: 'app-assurance-voyage-personnel',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-voyage-personnel.component.html',
  styleUrls: ['./assurance-voyage-personnel.component.scss']
})
export class AssuranceVoyagePersonnelComponent {
  title = 'Assurance Voyage Personnel';
  subtitle = '';
  heroImage = 'assets/static_pages_images/voyage.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Voyage Personnel', link: undefined }
  ];

  prevPage = { title: 'Retraite Complémentaire Salarié',
    link: '/assurance-retraite-complementaire-salarie'
  };

  nextPage = { title: 'Crédit Emprunteur',
    link: '/assurance-credit-emprunteur'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'CARDIF', logo: 'assets/images/logos/cardif-logo.png' },
    { name: 'UTWIN', logo: 'assets/images/logos/utwin-logo.png' },
    { name: 'NEOLIANE', logo: 'assets/images/logos/neoliane-logo.png' },
    { name: 'AFIESCA', logo: 'assets/images/logos/afiesca-logo.png' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}

